import React, { FunctionComponent } from 'react'

export interface Props {
  path: string | null
}

export const UserVerificationRow: FunctionComponent<Props> = ({
  children,
  path,
}) => {
  if (path) {
    return (
      <a
        className="user-verifications__row user-verifications__row--link"
        href={path}
        data-test="user-verification-row"
      >
        {children}
      </a>
    )
  } else {
    return <div className="user-verifications__row">{children}</div>
  }
}

UserVerificationRow.displayName = 'UserVerificationsRow'
